import Icon from "src/shared/icons"
import "./TableCard.css"
import { EstadoMesa } from "src/gql/schema"
import { CSSProperties, useEffect, useState } from "react"
import { useDate } from "src/shared/hooks/useDate"
import { useToggleFlag } from "src/shared/hooks/useToggleFlag"
import { useCurrentDate } from "src/shared/providers/CurrentdateProvider"
import { formatTime } from "src/shared/utils/formatTime"
import { useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { useProfile } from "src/shared/hooks/useProfile"
import useGetWindowSize from "./hooks/useGetWindowSize"

export const TableCard = ({ onSelect, mesa, style, testId = "" }: { onSelect: () => void; mesa: any; style?: CSSProperties, testId?: string }) => {
    const { zona_horaria } = useProfile()
    const { UTCStringToLocalDate } = useDate(zona_horaria)
    const [now] = useCurrentDate()
    const { tablesDimensions } = useSelector((state: RootState) => state.restaurant)
    
    const tableNumberHeight = `clamp(12px, calc(calc(80dvh - 240px) / ${(tablesDimensions?.x || 1) * 4}), 30px)`

    const tableTextHeight = `clamp(8px, calc(calc(80dvh - 400px) / ${(tablesDimensions?.x || 1) * 4}), 30px)`

    const rows = tablesDimensions?.x || 1
    const columns = tablesDimensions?.y || 1
    const divisor = (rows || 1) * 4

    const { windowSize } = useGetWindowSize()

    // TODO: 1 validar este texto y cambiar el clamp en min de los de más (debe ser mas chico para que sea min 12)
    const waiterHeight = `clamp(12px, calc(calc(80dvh - 300px) / ${(tablesDimensions?.x || 1) * 4}), 30px)`
    const textMaxWidth =  `clamp(12px, calc(calc(80dvh - 300px) / ${Math.round(((windowSize.x + windowSize.y) / 2) / ((rows + columns) / 2)) - 50}px), 30px)` 
    const stateHeight = tableNumberHeight
    const iconWrapperHeight = `clamp(18px, ${Math.round((windowSize.y * 1 - 100) / (divisor  + 2))}px, 50px)`

    const iconHeight = `clamp(15px, ${Math.round((windowSize.y * 0.8 - 100) / (divisor + 2))}px, 40px)`
    
    const footerItemHeight = `clamp(12px, calc(calc(80dvh - 400px) / ${(rows || 1) * 4}), 30px)`

    const state = mesa.estado_dinamico ? mesa.estado_dinamico.estado_activo : mesa.estado
    const waiter = mesa?.asignacion_actual?.colaborador_atendio ? `${mesa?.asignacion_actual?.colaborador_atendio?.nombre} ${mesa?.asignacion_actual?.colaborador_atendio?.apellido_paterno}` : "-"

    const mesaIcons = {
        disponible: "check",
        en_servicio: "UserParentFill",
        en_preparacion: "RecipeHistory",
        por_entregar: "Order",
        pago_pendiente: "IconPendingPayment",
        sucia: "trashFilled",
        bloqueada: "LockFill",
    }

    // LOGICA PARA EL TIMER
    const [timeOrder, setTimeOrder] = useState<string>("00:00")

    useEffect(() => {
        const registro = new Date(
            mesa?.estado_dinamico?.estado_activo === "pago_pendiente"
                ? UTCStringToLocalDate(mesa?.asignacion_actual?.fecha_cuenta_cerrada)
                : UTCStringToLocalDate(mesa?.estado_dinamico?.comanda_activa?.fecha_registro)
        )
        const diferencia = now.getTime() - registro.getTime()

        const minutos = Math.floor(diferencia / (1000 * 60))
        const segundos = Math.floor((diferencia % (1000 * 60)) / 1000)

        setTimeOrder(`${minutos.toString().padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`)
    }, [mesa?.estado_dinamico?.comanda_activa?.fecha_registro, mesa?.fecha_modificacion, now])

    // LOGICA DEL COLOR
    function getClassName(timeOrder: string) {
        const [minutes, seconds] = timeOrder.split(":").map(Number)

        if (minutes < 25 || (minutes === 24 && seconds <= 59)) {
            return ""
        } else {
            return "restaurant-very-late" // Rojo: 25 en adelante
        }
    }

    const isFirstColor = useToggleFlag()

    return (
        <div
            style={{
                ...style,
                backgroundColor:
                    state === "por_entregar"
                        ? isFirstColor
                            ? "var(--ocupada-card-1)"
                            : "var(--pink-ocupado-light)"
                        : undefined,
            }}
            className={`table-card__wrapper${` state-${state}`}`}
            onClick={onSelect}
            data-testid={testId}
            data-state={state}
        >
            {/* HEADER */}
            <div className="table-card--icon_wrapper__header">
                <div className={`table-card--icon_wrapper${` icon-${state}`}`} style={{
                    width: iconWrapperHeight,
                    height: iconWrapperHeight
                }}>
                    <Icon
                        name={mesaIcons[state]}
                        color="#FFF"
                        secondarycolor={state === "pago_pendiente" ? "var(--error)" : ""}
                        width={iconHeight}
                        height={iconHeight}
                    />
                </div>
                <div className="table_card--info_table">
                    <p className="table_card--info_table_title" style={{fontSize: tableTextHeight}}>Mesa</p>
                    <p className="table_card--info_table_text" style={{fontSize: tableNumberHeight}}>{mesa.numero_mesa.toString().padStart(2, "0")}</p>
                </div>

            </div>
            {/* BODY */}
            {state === EstadoMesa.Disponible || state === EstadoMesa.Sucia || state === EstadoMesa.Bloqueada ? (
                <div className="table-card--state_wrapper">
                    <p className="table-card--state_text" style={{fontSize: stateHeight, maxWidth: textMaxWidth}}>
                        {state === EstadoMesa.Bloqueada
                            ? mesa.motivo_bloqueo
                            : mesa.estado.charAt(0).toUpperCase() + mesa.estado.slice(1).toLowerCase()}
                    </p>
                </div>
            ) : state === EstadoMesa.EnServicio ? (
                <div className="table-card--state_wrapper_service">
                    <p className="table-card--state_servicio_text" style={{fontSize: stateHeight, maxWidth: textMaxWidth}}>{waiter}</p>
                    <p className="table-card--state_subtitle" style={{fontSize: waiterHeight}}>En servicio</p>
                </div>
            ) : (
                <div className="table-card--state_wrapper_service">
                    <p className={`table-card--state_text ${getClassName(timeOrder)}`} style={{fontSize: stateHeight, maxWidth: textMaxWidth}}>
                        {timeOrder.includes("NaN") ? "-" : formatTime({ time: timeOrder, withHours: true })}
                    </p>
                    <p className="table-card--state_subtitle" style={{fontSize: waiterHeight, maxWidth: textMaxWidth}}>{waiter}</p>
                </div>
            )}
            {/* FOOTER */}
            <div className="table-card--info_wrapper">
                <div className="table_card--info_persons">
                    <Icon name="UserParentFill" width={footerItemHeight} height={footerItemHeight} />
                    <p className="table_card--info_persons_text" style={{fontSize: footerItemHeight}}>{mesa.cantidad_personas}</p>
                </div>
            </div>
        </div>
    )
}

export default TableCard
